module.exports = __webpack_public_path__ + "lp/img/color_palette-darkgray.9889f63c.svg";